/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import Tooltip from 'react-simple-tooltip';
import get from 'lodash/get';
import { compose } from 'lodash/fp';
import { withNamespaces } from 'react-i18next';
import { processAnalyticsResultsMapData } from '../../../../../utils/analytics';
import { SafePureComponent } from '../../../../../utils/SafePureComponent';
import applyPluralRule from '../../../../../utils/pluralRule';
import scrollBlocker from '../../../../../utils/scrollBlocker';
import { RICH_FILTERING as dict } from '../../../../../utils/dictionarykeys';
import { colorsPalette } from '../../../../../styles/colors';
import { Breakpoints } from '../../../../../styles/Grid/GridSizes';
import { Icon } from '../../../../ui/Icon';
import createButtonCss from '../../../../ui/Button/Button';
import { withConsumer } from '../../../../../contexts';
import { RichFilteringConsumer } from '../../../../../contexts/RichFilteringContext';
import * as styles from './index.styles';

class RichFilteringGridHero extends SafePureComponent {
  scrollYPosition = 0;

  onClickToggleMap = () => {
    const { toggleMapVisibility } = get(
      this.props,
      'richFilteringContext.actions',
    );
    const { showMap } = get(this.props, 'richFilteringContext.state');

    toggleMapVisibility();

    if (window.innerWidth < Breakpoints.md) {
      if (!showMap) {
        this.scrollYPosition = window.scrollY;
        window.scroll(0, 0);
        scrollBlocker.enable();
        return;
      }

      scrollBlocker.disable();
      window.scroll(0, this.scrollYPosition);
    }

    processAnalyticsResultsMapData(showMap ? 'Hide map' : 'Show map');
  };

  onResize = () => {
    const { toggleMapVisibility } = get(
      this.props,
      'richFilteringContext.actions',
    );
    //console.log(window.innerWidth, Breakpoints.lg);
    if (window.innerWidth < Breakpoints.lg) {
      //toggleMapVisibility(false);
      return;
    }
    scrollBlocker.disable();
    //toggleMapVisibility(true);
  };

  componentDidMount() {
    window.addEventListener('resize', this.onResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  safeRender() {
    const { fields, locations, t } = this.props;
    const { DisclaimerPriceText, DisclaimerPriceTooltip } = fields;
    const locationsLength = locations.length;
    const { showMap } = get(this.props, 'richFilteringContext.state');
    const buttonText = showMap ? t(dict.HIDE_MAP) : t(dict.SHOW_MAP);

    const locationsLabel = applyPluralRule({
      quantity: locationsLength,
      dictionary: 'locationslabel',
    });

    return (
      <React.Fragment>
        <span>
          <span css={styles.locations}>
            {locationsLength} {locationsLabel}
          </span>
          <span>
            <span css={styles.locationsDisclaimer}>
              {DisclaimerPriceText.value}
            </span>
            <Tooltip
              content={get(DisclaimerPriceTooltip, 'value', '')}
              customCss={styles.tooltip}
              background={colorsPalette.white}
              border={colorsPalette.white}
            >
              {/* TODO: change this icon to new approach of icons */}
              <Icon
                customCss={styles.locationDisclaimerIcon}
                name="tooltip-2"
              />
            </Tooltip>
          </span>
        </span>
        <span css={styles.buttonWrap(showMap)}>
          <button
            onClick={this.onClickToggleMap}
            css={[createButtonCss('tertiary'), styles.button]}
          >
            <span css={styles.buttonText}>{buttonText}</span>
            <i css={styles.mapIcon} className="icon-map" />
          </button>
        </span>
      </React.Fragment>
    );
  }
}

RichFilteringGridHero.defaultProps = {
  t: key => `dict-${key}`,
};

export default compose(
  withNamespaces(),
  withConsumer(RichFilteringConsumer, 'richFilteringContext'),
)(RichFilteringGridHero);
